import BuildObjectButton from '../../../card/BuildObjectButton';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultCardAction = ({
  associationTypeData,
  canEditAssociation,
  canEditAssociationMessageOverride,
  toObjectTypeId,
  fromObjectId,
  fromObjectTypeId,
  hasScope,
  objectTypePermissions
}) => {
  return /*#__PURE__*/_jsx(BuildObjectButton, {
    associationObjectTypeId: toObjectTypeId,
    associationTypeId: associationTypeData.associationTypeId,
    associationCategory: associationTypeData.associationCategory,
    canEditAssociation: canEditAssociation,
    canEditAssociationMessageOverride: canEditAssociationMessageOverride,
    fromObjectId: fromObjectId,
    fromObjectTypeId: fromObjectTypeId,
    toObjectTypeId: toObjectTypeId,
    hasScope: hasScope,
    objectTypePermissions: objectTypePermissions
  });
};
export default DefaultCardAction;